<template>
  <div>
    <f7-block class="content__login">
      <div class="login__logo text-align-center">
        <img
          class="login__logo__img img_logo"
          :src="APP_LOGO"
          :alt="APP_NAME"
        />
      </div>

      <f7-list form no-hairlines-between class="no-margin-bottom">
        <f7-list-item class="login__heading">
          <!-- {{ $t('access') }} -->
          {{ $t('welcome_back') }}
        </f7-list-item>

        <f7-list-input
          class="input__text input__text--login"
          outline
          item-label
          type="text"
          :placeholder="$t('email')"
          max="255"
          required
          validate
          :error-message="$t('requiredField')"
          @input="email = $event.target.value"
          @keyup.enter.native="signIn"
        />
        <f7-list-input
          class="input__password input__password--login"
          outline
          item-label
          :type="showPassword ? 'text' : 'password'"
          :placeholder="$t('password')"
          max="255"
          required
          autocomplete="current-password"
          validate
          :error-message="$t('requiredField')"
          @input="password = $event.target.value"
          @keyup.enter.native="signIn"
        >
          <!-- prueba #inner-end; si no sale, usa #content-end o #end -->
          <template #inner-end>
            <button
              type="button"
              class="toggle-password"
              :aria-pressed="showPassword"
              :aria-label="
                showPassword
                  ? 'Ocultar contraseña'
                  : 'Mostrar contraseña'
              "
              @mousedown.prevent
              @click="showPassword = !showPassword"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  :d="
                    showPassword
                      ? icons.visibility
                      : icons.visibility_off
                  "
                  fill="currentColor"
                />
              </svg>
              <!-- Si prefieres el SVG exacto de Figma:
            <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
              <path d="TU_PATH" fill="currentColor"/>
            </svg>
            --></button>
          </template>
        </f7-list-input>
      </f7-list>

      <!-- inputs ... -->

      <!-- Fila: Recuérdame (izda) + Olvidó su contraseña (dcha) -->
      <!-- <f7-list class="login__meta no-margin-top" no-hairlines no-hairlines-between>
        <f7-list-item
          v-if="hasRememberMe"
          class="login__remember"
          checkbox
          name="checkRememberMe"
          :title="$t('remember_me')"
          :checked="wantRememberPassword"
          @change="TOGGLE_WANT_REMEMBER_PASSWORD"
        />
        <f7-list-item v-if="hasRestorePass" class="login__forgot-item">
          <f7-link class="login__forgot" href="#" @click="initUserRecoveryPassword">
            {{ $t('forgot_password') }}
          </f7-link>
        </f7-list-item>
      </f7-list> -->

      <div class="login__meta no-margin-top">
        <label class="login__remember">
          <f7-checkbox
            name="checkRememberMe"
            :checked="wantRememberPassword"
            @change="TOGGLE_WANT_REMEMBER_PASSWORD"
          ></f7-checkbox>
          <span>{{ $t('remember_me') }}</span>
        </label>
        <f7-link
          class="login__forgot"
          href="#"
          @click="initUserRecoveryPassword"
        >
          {{ $t('forgot_password') }}
        </f7-link>
      </div>

      <!-- Botón -->
      <f7-list class="login__actions no-margin-top">
        <f7-button
          name="btnSignIn"
          class="margin-horizontal login__btn"
          large
          fill
          :disabled="isSignInDisabled"
          @click="signIn"
        >
          <span class="text-color-white">{{ $t('sign_in') }}</span>
        </f7-button>

        <!-- Botón secundario (Crear nueva cuenta) -->
        <f7-button
          name="btnSignUp"
          class="margin-horizontal login__btn login__btn--secondary"
          large
          @click="addNewUser"
        >
          {{ $t('addNewUser') }}
        </f7-button>
      </f7-list>

      <f7-row>
        <!-- <f7-col>
          <div
            v-if="hasRestorePass"
            class="login__recovery text-align-center"
          >
            <f7-link
              class="login__recovery__link"
              href="#"
              @click="addNewUser"
            >
              {{ $t('addNewUser') }}
            </f7-link>
          </div>
        </f7-col> -->
        <f7-col>
          <div v-if="false" class="login__recovery text-align-center">
            <f7-link
              class="login__recovery__link"
              href="#"
              @click="initUserRecoveryPassword"
            >
              {{ $t('forgot_password') }}
            </f7-link>
          </div>
        </f7-col>
      </f7-row>

      <!-- Helpers bar -->
      <div v-if="hasNeedHelp" class="login__helpers">
        <div class="helpers__wrap">
          <span class="helpers__label">{{ $t('need_help') }}</span>
          <div class="helpers__links">
            <a
              href="#"
              class="helpers__link"
              @click="onOpenAccessGuideHandler"
            >
              {{ $t('howToAddNewUser') }}
            </a>
            <a
              href="#"
              class="helpers__link"
              @click="onOpenSupportHandler"
            >
              {{ $t('supportCenter') }}
            </a>
          </div>
        </div>
      </div>

      <DxPopup
        :visible="openedPopup"
        :drag-enabled="false"
        :close-on-outside-click="true"
        :show-title="false"
        height="auto"
        :width="1080"
        :show-close-button="false"
        @hiding="closeAccessGuidePopup()"
      >
        <div class="access-guide-popup">
          <button
            type="button"
            class="access-guide-popup__close"
            aria-label="Close access guide"
            @click="closeAccessGuidePopup"
          >
            x
          </button>
          <div class="access-guide-popup__frame">
            <iframe
              v-if="openedPopup && selectedAccessGuideVideo"
              class="access-guide-popup__video"
              :src="selectedAccessGuideVideoAutoplayUrl"
              :title="selectedAccessGuideVideo.title"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </DxPopup>
    </f7-block>

    <footer style="position: fixed; bottom: 0px; width: 100%">
      <f7-row>
        <f7-col></f7-col>
        <f7-col
          style="
            display: flex;
            justify-content: flex-end;
            padding-right: 50px;
            padding-bottom: 6px;
          "
        >
          <!-- <f7-link
            class="login__recovery__link"
            href="#"
            @click="onOpenPrevBesafer"
          >
            {{ $t('prevBesafer') }}
          </f7-link> -->
        </f7-col>
      </f7-row>
    </footer>
  </div>
</template>

<script>
import {
  APP_LOGO,
  APP_NAME,
  ALL_LANGUAGES,
  NOTIFY_TIME_LONGER,
} from '@/js/constants';
import notify from 'devextreme/ui/notify';
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import { defaultLocale } from '@/i18n';
import esMessages from '@/json/langs/es.json';
import itMessages from '@/json/langs/it.json';
import ptMessages from '@/json/langs/pt.json';
import enMessages from '@/json/langs/en.json';
import frMessages from '@/json/langs/fr.json';

import { locale, loadMessages } from 'devextreme/localization';
import { DxPopup } from 'devextreme-vue/popup';

export default {
  name: 'Login',
  components: {
    DxPopup,
  },
  props: {
    hasRestorePass: {
      type: Boolean,
      default: false,
    },
    hasSignUp: { type: Boolean, default: false },
    hasRememberMe: {
      type: Boolean,
      default: false,
    },
    hasNeedHelp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      icons: {
        visibility:
          'M14.877 8.62301C15.2833 9.02951 15.5974 9.52343 15.8192 10.1048C16.041 10.6863 16.125 11.2699 16.071 11.8558C16.071 12.0481 16.0018 12.2109 15.8635 12.3443C15.725 12.4776 15.5595 12.5443 15.3672 12.5443C15.1749 12.5443 15.012 12.4776 14.8787 12.3443C14.7454 12.2109 14.6787 12.0481 14.6787 11.8558C14.7429 11.4161 14.7067 10.9994 14.5702 10.6058C14.4337 10.2123 14.2238 9.87385 13.9405 9.59051C13.6571 9.30718 13.3155 9.0921 12.9155 8.94526C12.5155 8.79843 12.0936 8.76026 11.65 8.83076C11.4576 8.83726 11.2916 8.77285 11.152 8.63751C11.0121 8.50235 10.939 8.33859 10.9327 8.14626C10.9262 7.95393 10.988 7.78785 11.1182 7.64801C11.2484 7.50835 11.4096 7.43534 11.602 7.42901C12.184 7.36234 12.7689 7.43826 13.3567 7.65676C13.9445 7.87543 14.4513 8.19751 14.877 8.62301ZM12 6.00001C11.6448 6.00001 11.2964 6.01735 10.9547 6.05201C10.613 6.08651 10.273 6.14351 9.93445 6.22301C9.72162 6.26668 9.52995 6.23626 9.35945 6.13176C9.18895 6.02726 9.0717 5.87693 9.0077 5.68076C8.94354 5.47826 8.9647 5.28568 9.0712 5.10301C9.17754 4.92035 9.33195 4.80718 9.53445 4.76351C9.93712 4.66735 10.3439 4.59943 10.7547 4.55976C11.1657 4.51993 11.5808 4.50001 12 4.50001C14.1486 4.50001 16.1224 5.05835 17.9212 6.17501C19.7199 7.29168 21.1031 8.8026 22.071 10.7078C22.1376 10.8346 22.186 10.9624 22.2162 11.0913C22.2464 11.2201 22.2615 11.3563 22.2615 11.5C22.2615 11.6437 22.249 11.7799 22.224 11.9088C22.199 12.0376 22.1531 12.1654 22.0865 12.2923C21.7801 12.9333 21.4077 13.531 20.9692 14.0855C20.5307 14.64 20.048 15.1493 19.521 15.6135C19.366 15.752 19.1888 15.8093 18.9895 15.7855C18.79 15.7618 18.6261 15.6622 18.498 15.4865C18.3698 15.3108 18.3166 15.1224 18.3385 14.9213C18.3603 14.7199 18.4487 14.55 18.6037 14.4115C19.055 14.0025 19.4666 13.5554 19.8385 13.0703C20.2103 12.5849 20.5308 12.0615 20.8 11.5C19.9666 9.81668 18.7625 8.47918 17.1875 7.48751C15.6125 6.49585 13.8833 6.00001 12 6.00001ZM12 18.5C9.89479 18.5 7.96529 17.9375 6.21145 16.8125C4.45762 15.6875 3.06345 14.2058 2.02895 12.3673C1.94562 12.2404 1.8847 12.1026 1.8462 11.9538C1.8077 11.8051 1.78845 11.6538 1.78845 11.5C1.78845 11.3462 1.80512 11.1974 1.83845 11.0538C1.87179 10.9103 1.93012 10.7699 2.01345 10.6328C2.38529 9.95326 2.80645 9.3061 3.27695 8.69126C3.74745 8.0766 4.28845 7.52568 4.89995 7.03851L2.6422 4.76526C2.50387 4.6166 2.43562 4.44001 2.43745 4.23551C2.43945 4.03101 2.51287 3.85635 2.6577 3.71151C2.80254 3.56668 2.9782 3.49426 3.1847 3.49426C3.39104 3.49426 3.56662 3.56668 3.71145 3.71151L20.2885 20.2885C20.427 20.427 20.5004 20.5984 20.5087 20.8028C20.517 21.0073 20.4436 21.1871 20.2885 21.3423C20.1436 21.4871 19.968 21.5595 19.7615 21.5595C19.5551 21.5595 19.3795 21.4871 19.2347 21.3423L15.7155 17.8538C15.1256 18.0819 14.5195 18.2467 13.897 18.348C13.2746 18.4493 12.6423 18.5 12 18.5ZM5.95395 8.09226C5.36795 8.54493 4.84129 9.05676 4.37395 9.62776C3.90662 10.1989 3.51529 10.823 3.19995 11.5C4.03329 13.1833 5.23745 14.5208 6.81245 15.5125C8.38745 16.5042 10.1166 17 12 17C12.4295 17 12.8522 16.9712 13.2682 16.9135C13.6842 16.8558 14.0974 16.7668 14.5077 16.6463L13.2422 15.35C13.0397 15.4385 12.8375 15.4984 12.6355 15.5298C12.4336 15.5613 12.2218 15.577 12 15.577C10.8653 15.577 9.90212 15.1812 9.11045 14.3895C8.31879 13.5978 7.92295 12.6347 7.92295 11.5C7.92295 11.2782 7.94029 11.0663 7.97495 10.8645C8.00962 10.6625 8.06795 10.4603 8.14995 10.2578L5.95395 8.09226Z',
        visibility_off:
          'M12.0022 15.577C13.1354 15.577 14.0978 15.1804 14.8895 14.3872C15.6811 13.5941 16.077 12.6309 16.077 11.4978C16.077 10.3646 15.6804 9.40217 14.8872 8.6105C14.094 7.81883 13.1309 7.423 11.9977 7.423C10.8645 7.423 9.90212 7.81958 9.11046 8.61275C8.31879 9.40592 7.92296 10.3691 7.92296 11.5023C7.92296 12.6354 8.31954 13.5978 9.11271 14.3895C9.90587 15.1812 10.869 15.577 12.0022 15.577ZM12 14.2C11.25 14.2 10.6125 13.9375 10.0875 13.4125C9.56245 12.8875 9.29995 12.25 9.29995 11.5C9.29995 10.75 9.56245 10.1125 10.0875 9.5875C10.6125 9.0625 11.25 8.8 12 8.8C12.75 8.8 13.3875 9.0625 13.9125 9.5875C14.4375 10.1125 14.7 10.75 14.7 11.5C14.7 12.25 14.4375 12.8875 13.9125 13.4125C13.3875 13.9375 12.75 14.2 12 14.2ZM12 18.5C9.89479 18.5 7.96946 17.9384 6.22396 16.8152C4.47846 15.6922 3.0852 14.2148 2.0442 12.3828C1.96087 12.2391 1.89995 12.0943 1.86145 11.9485C1.82312 11.8027 1.80396 11.653 1.80396 11.4995C1.80396 11.346 1.82312 11.1965 1.86145 11.051C1.89995 10.9055 1.96087 10.7609 2.0442 10.6172C3.0852 8.78525 4.47846 7.30775 6.22396 6.18475C7.96946 5.06158 9.89479 4.5 12 4.5C14.1051 4.5 16.0305 5.06158 17.776 6.18475C19.5215 7.30775 20.9147 8.78525 21.9557 10.6172C22.039 10.7609 22.1 10.9057 22.1385 11.0515C22.1768 11.1973 22.196 11.347 22.196 11.5005C22.196 11.654 22.1768 11.8035 22.1385 11.949C22.1 12.0945 22.039 12.2391 21.9557 12.3828C20.9147 14.2148 19.5215 15.6922 17.776 16.8152C16.0305 17.9384 14.1051 18.5 12 18.5ZM12 17C13.8833 17 15.6125 16.5042 17.1875 15.5125C18.7625 14.5208 19.9666 13.1833 20.8 11.5C19.9666 9.81667 18.7625 8.47917 17.1875 7.4875C15.6125 6.49583 13.8833 6 12 6C10.1166 6 8.38745 6.49583 6.81246 7.4875C5.23746 8.47917 4.03329 9.81667 3.19995 11.5C4.03329 13.1833 5.23746 14.5208 6.81246 15.5125C8.38745 16.5042 10.1166 17 12 17Z',
      },
      APP_LOGO,
      APP_NAME,
      failedLoginCounter: 0,
      langsDx: {
        esMessages,
        frMessages,
        ptMessages,
        enMessages,
        itMessages,
      },
      accessGuideVideos: {
        es: {
          title: 'Nueva contraseña Besafer',
          url: 'https://www.youtube.com/embed/WY_uglEfPpo',
        },
        en: {
          title: 'New password Besafer',
          url: 'https://www.youtube.com/embed/Q4A8Wl48mII',
        },
        fr: {
          title: 'Nouveau mot de passe Besafer',
          url: 'https://www.youtube.com/embed/DGbx1ajIMro',
        },
        it: {
          title: 'Nuova Password BeSafer',
          url: 'https://www.youtube.com/embed/ACEvULEfUXg',
        },
        pt: {
          title: 'Nova palavra-passe Besafer',
          url: 'https://www.youtube.com/embed/ioKHFr7Kez4',
        },
      },
      openedPopup: false,
      chosenLanguage: '',
    };
  },
  computed: {
    ...mapGetters('user', ['userProfile']),
    ...mapState('user', [
      'isUserLoggedIn',
      'wantRememberPassword',
      'authenticatedUser',
    ]),
    ...mapState('contact', ['enabled']),
    selectedAccessGuideVideo() {
      return (
        this.accessGuideVideos[this.chosenLanguage] ||
        this.accessGuideVideos[defaultLocale]
      );
    },
    selectedAccessGuideVideoAutoplayUrl() {
      if (!this.selectedAccessGuideVideo) {
        return '';
      }

      return `${this.selectedAccessGuideVideo.url}?autoplay=1&rel=0`;
    },
    isSignInDisabled() {
      return (
        !this.username && !this.wantRememberPassword && !this.password
      );
    },
  },
  mounted() {
    const navigatorLanguage = navigator.language
      .substring(0, 2)
      .toLowerCase();

    this.chosenLanguage = this.isLanguageValid(navigatorLanguage)
      ? navigatorLanguage
      : defaultLocale;
  },
  methods: {
    onOpenSupportHandler() {
      let mail = '';

      if (this.chosenLanguage === 'es') {
        mail = 'atencioncliente.esp@agqlabs.com';
      } else if (this.chosenLanguage === 'en') {
        mail = 'info@agqlabs.com';
      } else if (this.chosenLanguage === 'it') {
        mail = 'italia@agqlabs.com';
      } else if (this.chosenLanguage === 'pt') {
        mail = 'infoportugal@agqlabs.com';
      }
      window.open(`mailto:${mail}`, '_blank');
    },
    isLanguageValid(language) {
      let valid = false;
      for (const lang in ALL_LANGUAGES) {
        if (ALL_LANGUAGES[lang].value === language) {
          valid = true;
        }
      }

      return valid;
    },
    ...mapActions('user', [
      'authenticate',
      'toggleWantRememberPassword',
    ]),
    ...mapMutations('user', [
      'TOGGLE_WANT_REMEMBER_PASSWORD',
      'SET_USER_RECOVERING_PASSWORD',
    ]),
    translateLanguage(value) {
      let key = '';
      for (const lang in ALL_LANGUAGES) {
        if (ALL_LANGUAGES[lang].key === value) {
          key = ALL_LANGUAGES[lang].value;
        }
      }

      return key;
    },
    getLangDevx(lang) {
      if (lang === 'it') {
        return itMessages;
      }
      if (lang === 'fr') {
        return frMessages;
      }

      if (lang === 'es') {
        return esMessages;
      }

      if (lang === 'pt') {
        return ptMessages;
      }

      if (lang === 'en') {
        return enMessages;
      }

      // Por defecto, español
      return esMessages;
    },
    onOpenAccessGuideHandler() {
      this.openedPopup = true;
    },
    closeAccessGuidePopup() {
      this.openedPopup = false;
    },
    onOpenPrevBesafer() {
      window.open('https://prev.besafer.info/', '_blank');
    },
    clearNotifications() {
      // Cierra toasts activos
      notify('', 'clear');

      // Elimina manualmente contenedores que DevExtreme mantiene en el DOM
      const leftover = document.querySelectorAll(
        '.dx-toast-wrapper, .dx-toast'
      );
      leftover.forEach((el) => el.remove());
    },
    async signIn() {
      try {
        this.clearNotifications();

        this.$f7.preloader.show();

        await this.authenticate({
          email: this.email,
          password: this.password,
          isEmail: this.isEmail(this.email),
        });

        this.clearNotifications();

        if (this.enabled) {
          const lang = this.userProfile.language
            ? this.translateLanguage(this.userProfile.language)
            : navigator.language.substring(0, 2).toLowerCase();

          locale(`${lang}-${lang.toUpperCase()}`);
          loadMessages(this.langsDx[`${lang}Messages`]);

          setTimeout(() => {
            this.$i18n.i18next.changeLanguage(lang);
            this.updateLanguageInterface(lang);
          }, 0);
        } else {
          const lang = this.authenticatedUser.language_code
            ? this.translateLanguage(
                this.authenticatedUser.language_code
              )
            : navigator.language.substring(0, 2).toLowerCase();

          locale(`${lang}-${lang.toUpperCase()}`);
          loadMessages(this.langsDx[`${lang}Messages`]);

          setTimeout(() => {
            this.$i18n.i18next.changeLanguage(lang);
            this.updateLanguageInterface(lang);
          }, 0);
        }
      } catch (error) {
        this.clearNotifications();
        if (error.message === 'contacts_not_found') {
          notify(
            {
              message: this.$t('empty_contacts'),
              width: 500,
            },
            'error',
            NOTIFY_TIME_LONGER
          );
        } else if (error.message === 'empty_headquarters') {
          notify(
            {
              message: this.$t('empty_headquarters'),
              width: 500,
            },
            'error',
            NOTIFY_TIME_LONGER
          );
        } else {
          notify(
            {
              message: this.$t(error.message),
              width: 500,
            },
            'error',
            NOTIFY_TIME_LONGER
          );
        }
      } finally {
        this.$f7.preloader.hide();
      }
    },
    isEmail(email) {
      return email.includes('@');
    },
    initUserRecoveryPassword() {
      this.setIsCreatingNewUser(false);
      this.SET_USER_RECOVERING_PASSWORD();
    },
    addNewUser() {
      this.setIsCreatingNewUser(true);
      this.SET_USER_RECOVERING_PASSWORD();
    },
    ...mapActions('user', [
      'updateLanguageInterface',
      'setIsCreatingNewUser',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.login__label {
  font-size: 24px;
  font-weight: 200;
}
.login__logo__img {
  width: 200px;
  height: auto;
}
.login__recovery__link {
  color: var(--f7-theme-color);
  background: var(--his-mora-tint);
  border: 1px solid var(--his-mora-tint);
  padding: 4px 12px;
  display: block;
  margin: 0 15px;
  border-radius: 4px;
}
.login__recovery__link:hover {
  background: var(--his-mora-tint);
  border-color: var(--his-mora-light);
}

.login__heading {
  font-weight: 600; /* Semi Bold */
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.48px; /* -2% */
  color: var(--Primary-Blue-60, #04509f); /* Primary/Blue 60 */
}

:deep(.login__heading .item-inner) {
  justify-content: center;
}

/* Ojo 24x24, sin “empujar” el alto */
.input__password--login .toggle-password {
  position: absolute;
  right: 27px;

  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  line-height: 0; /* evita que aumente altura */
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  padding: 0;
  color: rgba(0, 52, 106, 1);
  margin-top: 20px;
  cursor: pointer;
}
.input__password--login .toggle-password svg {
  display: block; /* elimina baseline */
}

/* estilo para el checkbox recuerdame */

/* Ajuste fino del checkbox “Recuérdame” para que coincida con Figma */
.login__remember {
  --f7-checkbox-size: 16px; /* tamaño exacto Figma */
  --f7-checkbox-border-width: 2px; /* borde 2px */
  --f7-checkbox-border-radius: 3px; /* radio 3px */
  --f7-checkbox-inactive-color: rgba(0, 52, 106, 1); /* azul */
  --f7-checkbox-active-color: rgba(0, 52, 106, 1);
  --f7-checkbox-bg-color: #fff;
  --f7-checkbox-icon-color: #fff;
}
.login__remember .checkbox {
  vertical-align: bottom !important;
}

/* Alineación y separación con el texto (opcional) */
.login__remember .item-inner {
  align-items: center;
  gap: 6px; /* ajusta a 6–8 según tu Figma */
}

/* Si aún lo ves grande: probablemente queda el fallback de 18px.
   Fuerza a que use las variables anteriores y no ese valor. */
.login__remember .item-checkbox .icon-checkbox {
  width: var(--f7-checkbox-size) !important;
  height: var(--f7-checkbox-size) !important;
  border-width: var(--f7-checkbox-border-width) !important;
  border-radius: var(--f7-checkbox-border-radius) !important;
  padding: 5px !important;
}

/* estilo para el texto recuerdame  */

/* Texto "Recuérdame" = Body S de Figma */
.login__remember .item-title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* ~19.6px */
  color: var(
    --Neutral-70,
    #3e3c44
  ); /* Neutral/70 de Figma con fallback */
  margin: 0; /* por si el tema añade margen */
}

/* estilo para olvido su contraseña */

/* Ambos bloques con el MISMO ancho y centrados */
.login__meta,
.login__actions {
  max-width: 456px;
  margin: 0 auto 12px;
  list-style: none; /* remove default bullets */
  padding-left: 16px; /* remove default padding */
  padding-right: 16px; /* remove default padding */
}

/* 2 columnas: izq (checkbox) / dcha (enlace) */
.login__meta {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Esto alinea los elementos verticalmente */
}

/* alinea el contenido del item derecho totalmente a la derecha */
:deep(.login__forgot-item .item-inner) {
  justify-content: flex-end;
}

/* estilo del enlace como en Figma: Body S Link */
.login__forgot {
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  color: var(--Neutral-70, #3e3c44);
  text-decoration: underline;
}

/* estilos para el boton iniciar sesion */

/* Botón "Iniciar sesión" igual que Figma */
.login__btn {
  /* mismo ancho que los inputs */
  max-width: 456px;
  margin: 0 auto 12px;

  /* alto/espaciado y radio */
  min-height: 40px; /* equivalente a padding 8px + texto */
  padding: 8px 16px; /* como en Figma */
  border-radius: 10px;

  /* colores (Primary/Blue 70) */
  --f7-button-bg-color: #00346a; /* estado normal */
  --f7-button-hover-bg-color: #00346a; /* hover: igual que normal */
  --f7-button-pressed-bg-color: #002c59; /* hover/active */
  --f7-button-text-color: #fff;

  /* tipografía del label */
  font-size: 14px;
  font-weight: 600;
  line-height: 24px; /* 140% aprox. del 14px */
  letter-spacing: 0;

  /* limpia estilos del tema */
  box-shadow: none;
}

/* estado deshabilitado (como tu mock grisado) */
.login__btn.button-disabled,
.login__btn[disabled] {
  background: rgba(0, 52, 106, 0.35) !important;
  color: #fff !important;
}

/* opcional: centra el contenido por si el tema mete algo extra */
.login__btn .button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px; /* como en Figma */
  align-self: stretch;
}

/** estilos para el boton crear nueva cuenta  */

/* Lista de acciones con el mismo ancho que inputs */
.login__actions {
  max-width: 456px;
  margin: 0 auto 12px;
  padding-left: 0;
  padding-right: 0;
}

/* Botón secundario: borde azul, fondo blanco */
.login__btn--secondary {
  /* tamaño/espaciado iguales al primario */
  max-width: 456px;
  margin: 0 auto 12px;
  min-height: 36px; /* en Figma: 36px */
  padding: 8px 16px;
  border-radius: 10px;

  /* colores */
  background: #fff !important; /* Basic/White */
  border: 1px solid #00346a !important; /* Primary/Blue 70 */
  color: #00346a !important;

  /* tipografía */
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;

  box-shadow: none; /* sin sombras */
}

/* Hover/active sutiles (opcional) */
.login__btn--secondary:active,
.login__btn--secondary:focus {
  background: #f6f8fb !important; /* un blanco ligeramente gris */
}

/** estilos para la nueva fila de necesita ayuda , documentacion y centro de soporte */

/* Quita el padding lateral del f7-block SOLO para esta fila */
.login__helpers {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

/* La fila usa el MISMO ancho que inputs/botones y queda centrada */
.login__helpers .helpers__wrap {
  width: 100%;
  margin: 12px auto 0; /* centrada bajo los botones */
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
}

/* Izquierda: label fuerte */
.login__helpers .helpers__label {
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  color: var(--Primary-Blue-70, #00346a);
  text-align: center;
}

/* Enlaces centro y derecha */
.login__helpers .helpers__links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.login__helpers .helpers__link {
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  color: var(--Primary-Blue-70, #00346a);
  text-decoration: underline;
  text-align: center;
}

/* Centrado perfecto y alineado a la derecha */
.login__helpers .helpers__link:nth-of-type(1) {
  justify-self: center;
} /* Documentación */
.login__helpers .helpers__link:nth-of-type(2) {
  justify-self: end;
} /* Centro de soporte */

.access-guide-popup {
  padding: 32px;
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  background: #fff;
  position: relative;
  box-sizing: border-box;
}

.access-guide-popup__close {
  position: absolute;
  top: 6px;
  right: 8px;
  z-index: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #6b7280;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.access-guide-popup__frame {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
}

.access-guide-popup__video {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
}

/* === Card blanco del formulario === */
.content__login {
  /* tamaño del card: inputs (456px) + padding 64px a cada lado */
  box-sizing: border-box;
  width: 100%;
  max-width: calc(456px + 64px * 2);
  // margin: 64px auto;
  padding: 64px; /* como en Figma */
  background: #fff; /* fondo blanco */
  border-radius: 10px; /* radios de 10px */
  box-shadow: 0 4px 4px -1px rgba(87, 84, 95, 0.3),
    0 8px 16px -6px rgba(0, 0, 0, 0.06); /* sombra suave */

  /* anula el padding/margen propios de <f7-block> */
  --f7-block-padding-horizontal: 0;
  --f7-block-padding-vertical: 0;
  --f7-block-margin-vertical: 0;
}

/* Asegura que los “subbloques” se mantengan a 456px y centrados */
.content__login .list,
.content__login .login__actions,
.content__login .login__meta,
.content__login .helpers__wrap {
  max-width: 456px;
  margin-left: auto;
  margin-right: auto;
}

/* Responsive: en móviles reduce el padding lateral para que no toque los bordes */
@media (max-width: 480px) {
  .content__login {
    padding: 24px;
    max-width: calc(456px + 24px * 2);
    margin: 24px auto;
  }
}

/* === Ritmo vertical según Figma === */

/* 1) Gap: “Bienvenido de nuevo”, Email = 32px */
.login__heading {
  margin-top: 32px;
  margin-bottom: 32px !important;
}

/* 2) Gap: Email, Contraseña  (ajusta si tu Figma usa 16px) */
.input__text--login {
  margin-bottom: 16px; /* o 12px/20px si tu Figma lo pide */
}

/* 3) Gap: Contraseña, fila Recuérdame/Olvidó = 12px (ajústalo si quieres 16) */
.input__password--login {
  margin-bottom: 12px;
}

/* 4) Gap: fila Recuérdame/Olvidó, Botón primario = 32px */
.login__meta {
  margin: 0 auto 32px !important; /* top 0, bottom 32 */
}

/* Aplica el espacio solo entre ellos */
.login__btn + .login__btn {
  margin-top: 24px !important;
}
</style>
